import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectPortfolioRealtimeStatisticsMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_PFIX_PORTFOLIO_REALTIME_STATISTICS);
        this.Account = null; // FIELD_ACCOUNT_ID[89]  идентификатор аккаунта в системе
        this.Type = null; // FIELD_TYPE[53]  тип статистики
        this.TotalReturn = null; // FIELD_TOTAL_RETURN[753]  значение параметра рассчитанного по формуле из п.5.1.1 https://docs.google.com/document/d/1eD8P5Ck4ZN6zmikSFYK3YpyAUdF09pR6w6hqS84y6aY/edit
        this.Groups = null; // PERCENT_INSTRUMENT_ROUTE_DAY_ENTRY_GROUP = 88  в данной группе будут передаваться значения долей по инструментам и кешу.Поле FIELD_DATE в группе всегда будет отсутствовать. Отсутствие полей FIELD_TRADABLE_INSTRUMENT_ID и FIELD_ROUTE_ID будет означать что это значение для “Cash”. В отличии от описания для группы, в поле FIELD_ROUTE_ID будет передавать идентификатор торгового роута.
    }
}
export class PortfolioAllocation {
}
